import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_management/vorgaenge/recherche/')({
  component: () => <Navigate to="/vorgaenge" />,
});
